module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/avatar-e9dce0dfa06b00aee090f31b80f66d87.svg";